import React, {useContext, useEffect, useState, useCallback} from "react";
import {WooContext} from "../WooSearchContext";
import reactStringReplace from "react-string-replace";
import SvgLink from "../SVG";
import {FONTELLO_MFGLABS_SEARCH} from "../SVG/consts";
import LoadSpinner from "../Elements/LoadSpinner";
import SaleProduct from "../Products/SaleProduct";

function Search() {
    const {searchQueryState, products, productMatchQuery, productMatchState, searchStringState, matchCategoryState, matchTagState, productCategoriesTags} = useContext(WooContext);
    const [,setSearchQuery] = searchQueryState;
    const [searchString, setSearchString] = searchStringState;
    const [productMatch, setProductMatch] = productMatchState;
    const [matchCategory, setMatchCategory] = matchCategoryState;
    const [partialCategoryMatch, setPartialCategoryMatch] = useState();
    const [,setMatchTag] = matchTagState;
    const [productsQueryExec, productsResponse] = products;
    const [productMatchQueryExec, productMatchQueryResponse] = productMatchQuery;
    const handleResetMatches = useCallback(() => {
        setMatchCategory();
        setMatchTag();
        setProductMatch();
        setSearchQuery();
        setPartialCategoryMatch();
    }, [setMatchCategory, setMatchTag, setProductMatch, setSearchQuery, setPartialCategoryMatch]);
    useEffect(() => {
        if(productMatchQueryResponse.data && productMatchQueryResponse.data.product) {
            setProductMatch(productMatchQueryResponse.data.product);
        }
    }, [productMatchQueryResponse, setProductMatch]);
    useEffect(() => {
        handleResetMatches();
        if(!searchString || searchString.length < 3) {
            return;
        }
        if (productCategoriesTags.data) {
            const matchCategoryResult = productCategoriesTags.data.productCategories.nodes.filter(categoryItem => categoryItem.name.toLowerCase() === searchString.toLowerCase());
            const matchTagResult = productCategoriesTags.data.productTags.nodes.filter(categoryTag => categoryTag.name.toLowerCase() === searchString.toLowerCase());
            const categoryPartialMatch = productCategoriesTags.data.productCategories.nodes.filter(categoryItem => {
                const catNameLower = categoryItem.name.toLowerCase();
                return catNameLower.indexOf(searchString.toLowerCase()) > -1;
            });
            setPartialCategoryMatch(categoryPartialMatch);
            setMatchCategory(matchCategoryResult.length ? matchCategoryResult[0] : null);
            setMatchTag(matchTagResult.length ? matchTagResult[0] : null);
            setSearchQuery((matchCategoryResult.length || matchTagResult.length) ? null: searchString);
            productsQueryExec();
        }
    }, [searchString, productCategoriesTags, handleResetMatches, productsQueryExec, setMatchCategory, setMatchTag, setSearchQuery]);
    useEffect(() => {
        if(productsResponse.data && productsResponse.data.products.nodes[0] && productsResponse.data.products.nodes[0].name.toLowerCase() === searchString.toLowerCase()) {
            handleResetMatches();
            setProductMatch(productsResponse.data.products.nodes[0]);
        }
    }, [productsResponse, searchString, handleResetMatches, setProductMatch]);
    return (
        <form className="header-search-inner" onSubmit={(e) => {
            e.preventDefault();
            if (productMatch) {
                window.location.href = productMatch.link;
            } else if (matchCategory) {
                window.location.href = matchCategory.uri;
            } else if(productsResponse && productsResponse.data && productsResponse.data.products.nodes[0]) {
                window.location.href = productsResponse.data.products.nodes[0].link;
            }
        }}>
            <div className="form-group form-group-search">
                <input autoComplete="off" type="text" disabled={productCategoriesTags.loading === true && (searchString && searchString.length === 2)} onChange={(e) => {
                    const searchStr = e.target.value;
                    setSearchString(searchStr);
                    if (searchStr.length > 5 && searchStr.match(/^\d*-\d*/)) {
                        handleResetMatches();
                        productMatchQueryExec({ variables: { sku: searchStr }});
                    }
                }} placeholder="Search our wide range of products..." name="search" />
                <button type="submit" className="button is-style-btn-secondary">
                    <span className="button-link">{productsResponse.loading ? <LoadSpinner /> : <SvgLink {...FONTELLO_MFGLABS_SEARCH}/>}</span>
                </button>
                {searchString && searchString.length > 2 &&
                    <div className="form-search-results">
                    {(!productMatch || !productMatch.name) &&
                        <ul className="autocomplete-search">
                            {!matchCategory && partialCategoryMatch && partialCategoryMatch.length > 0 &&
                            partialCategoryMatch.map((singleCategoryMatch) => (
                                <li>
                                    <a href={singleCategoryMatch.uri}>
                                        {reactStringReplace(singleCategoryMatch.name, searchString, (match) => (
                                            <strong>{match}</strong>
                                        ))}
                                    </a>
                                </li>
                            ))
                            }
                        {!productsResponse.loading && (!matchCategory || !matchCategory.name) && (!productsResponse || !productsResponse.data || !productsResponse.data.products.nodes.length) &&
                        <li className="no-results">No results found - <a href={'/request-product?q=' + searchString}>Request this product</a></li>}
                        </ul>}
                        <ul className="search-results">
                        {productMatch && productMatch.name && <SaleProduct simpleLayout={1} {...productMatch} />}
                        {matchCategory && matchCategory.name && <li><div className="category"><a href={matchCategory.uri}><h2>Category: {matchCategory.name}</h2></a></div></li>}
                        {!productMatch && productsResponse.data && productsResponse.data.products.nodes[0] && productsResponse.data.products.nodes.map((product, index) => (
                            <SaleProduct key={index} simpleLayout={1} {...product} />))}
                        </ul>
                    </div>
                }
            </div>
        </form>
    );
}

export default Search;